const IconModalError = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 50 50"
      className="mr-2"
    >
      <g
        id="Icon_ionic-ios-close-circle-outline"
        data-name="Icon ionic-ios-close-circle-outline"
        transform="translate(-3.375 -3.375)"
      >
        <path
          id="Path_21"
          data-name="Path 21"
          d="M34.529,31.313,27.017,23.8l7.512-7.512a2.278,2.278,0,1,0-3.222-3.222L23.8,20.579l-7.512-7.512a2.278,2.278,0,1,0-3.222,3.222L20.573,23.8l-7.512,7.512a2.2,2.2,0,0,0,0,3.222,2.263,2.263,0,0,0,3.222,0L23.8,27.022l7.512,7.512a2.289,2.289,0,0,0,3.222,0A2.263,2.263,0,0,0,34.529,31.313Z"
          transform="translate(4.579 4.573)"
          fill="#cb3a3a"
        />
        <path
          id="Path_22"
          data-name="Path 22"
          d="M28.375,6.74a21.638,21.638,0,0,1,15.3,36.935,21.638,21.638,0,0,1-30.6-30.6,21.491,21.491,0,0,1,15.3-6.334m0-3.365a25,25,0,1,0,25,25,25,25,0,0,0-25-25Z"
          fill="#cb3a3a"
        />
      </g>
    </svg>
  );
};
export default IconModalError;
